import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import BasicModal from '@/components/UI/Dialog'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'

const SelectQuestionTypeModal = (props: any) => {
  const { t } = useTranslation('translation')
  const [queType, setQueType] = useState([
    {
      isChecked: false,
      text: t('Multiple Choice Questions'),
      type: 'quiz_mcq',
    },
    { isChecked: false, text: t('Open-Ended Questions'), type: 'quiz_text' },
  ])
  const [disabled, setDisabled] = useState(true)
  const [questionCount, setQuestionCount] = useState(0)

  useEffect(() => {
    if (
      queType.some((e: any) => e.isChecked === true) &&
      questionCount >= 1 &&
      questionCount <= 20
    ) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [queType, questionCount])

  const selectedQueType = (event: any, i: any) => {
    let temp = [...queType]
    temp[i].isChecked = event
    setQueType(temp)
  }

  const onProceedHandler = (type: any, hide: boolean = false) => {
    if (props.type && props.type === 'summaries_document') {
      props.onProceed(
        type.filter((e: any) => e.isChecked === true),
        questionCount,
      )
    } else {
      if (hide) {
        setQueType([
          {
            isChecked: false,
            text: t('Multiple Choice Questions'),
            type: 'quiz_mcq',
          },
          {
            isChecked: false,
            text: t('Open-Ended Questions'),
            type: 'quiz_text',
          },
        ])
        setQuestionCount(0)
      }
      props.onProceed(
        type.filter((e: any) => e.isChecked === true),
        hide,
        questionCount,
      )
    }
  }

  return (
    <BasicModal
      open={props.show}
      onClose={() => onProceedHandler(queType, true)}
      title={t('Generate Quiz Questions')}
      sx={{ p: 2, width: '500px', height: 'auto' }}
    >
      <Box mt={2}>
        <Typography variant="body3" mt={2} mb={1}>
          {t('Enter number of questions (maximum: 20)')}
        </Typography>
        <input
          type="number"
          className="form-control radius-2 pl-2 no-spinners he-26"
          onChange={(e: any) => {
            setQuestionCount(e.target.value)
          }}
          min={1}
          max={20}
        />
        <Typography variant="body3" mt={2} mb={1}>
          {t('Select type(s) of questions')}
        </Typography>
        <Stack>
          {queType?.map((item: any, index) => (
            <FormControlLabel
              sx={{ m: 0 }}
              control={
                <Checkbox
                  key={item?.text || index}
                  checked={item.isChecked}
                  onChange={e => selectedQueType(e.target.checked, index)}
                />
              }
              label={item?.text}
            />
          ))}
        </Stack>
      </Box>
      <Stack direction="row" justifyContent="flex-end" mt={2} gap={2}>
        <Button
          variant="contained"
          onClick={() => onProceedHandler(queType, false)}
          disabled={disabled}
        >
          {t('Generate')}
        </Button>
      </Stack>
    </BasicModal>
  )
}

export default SelectQuestionTypeModal
